module.exports = __webpack_public_path__ + "img/bed-solid.cbf05425.svg";